import { actions, types } from './requests'
export const GETCLIENTORDERLIST_TYPES = {
    ...types('GETCLIENTORDERLIST'),
}
export const GETCLIENTORDERLIST_ACTIONS = {
    ...actions('GETCLIENTORDERLIST'),
}
